/*
Defines the custom element <ravel-signal>
*/

import { RavelSignal } from './src/RavelSignal.js';

customElements.define('ravel-signal', RavelSignal);
